import Vue from 'vue'
export const apiService = {
    validateRegistrationStep1,
    validateRegistrationStep2,
    validateRegistrationStep3,
    validateToken,
    processRegistering,
    forgotPassword,
    forgotPasswordConfirmation,
    resetPassword,
    resetPasswordConfirmation,
    getClientReportsList,
    processOnBoarding,
    resendCode,
};

const headersParam = {
    "Accept": "*/*",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
};

function validateRegistrationStep1(registration) {
    let url = "/api/validateregistrationstep1";

    return Vue.prototype.$axios.post(url, registration, headersParam)
        .then(handleResponse)
        .then((response) => {
            if(response.data.success)
            return response;
        });
}
function validateRegistrationStep2(params) {
    let url = "/api/validateregistrationstep2";

    return Vue.prototype.$axios.post(url, params, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
        });
}

function validateRegistrationStep3(data) {
    let url = "/api/validateregistrationstep3";

    return Vue.prototype.$axios.post(url, data, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
        });
}

function processRegistering(registration, ignoreUserDuplicates) {
    let url = ignoreUserDuplicates ? "/api/processRegisteringNoDupes" : "/api/processregistering";

    return Vue.prototype.$axios.post(url, registration, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
        });
}

function forgotPassword(ForgotPasswordViewModel) {
    let url = "/api/forgotpassword";

    return Vue.prototype.$axios.post(url, ForgotPasswordViewModel, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
        });
}

function forgotPasswordConfirmation(ForgotPasswordViewModel) {
    let url = "/api/forgotpasswordconfirmation";

    return Vue.prototype.$axios.post(url, ForgotPasswordViewModel, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
        });
}

function resetPassword(ResetPasswordViewModel) {
    let url = "/api/resetpassword";

    return Vue.prototype.$axios.post(url, ResetPasswordViewModel, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
            else
                throw new Error(response.data.error);
        });
}

function validateToken(ResetPasswordViewModel) {
    let url = "/api/validatetoken";

    return Vue.prototype.$axios.post(url, ResetPasswordViewModel, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
            else
                throw new Error(response.data.error);
        });
}

function resetPasswordConfirmation(ResetPasswordViewModel) {
    let url = "/api/resetpasswordconfirmation";

    return Vue.prototype.$axios.post(url, ResetPasswordViewModel, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
        });
}

function getClientReportsList() {
    let url = "/onboarding/getClientReportsList";

    return Vue.prototype.$axios.post(url, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
        });
}

function processOnBoarding(reports, ignoreUserDuplicates) {
    let url = ignoreUserDuplicates ? "/onboarding/processOnBoardingIgnoreDupes" : "/onboarding/processOnBoarding";

    return Vue.prototype.$axios.post(url, reports, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
        });
}

function resendCode(data) {
    let url = "/api/sendcontactvalidationcode";

    return Vue.prototype.$axios.post(url, data, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success) {
                return response;
            }
            else
                throw new Error(response.data.error);
        });
}
function handleResponse(response) {
    if (!response.data?.success) {

        const error = response.data?.error || response.statusText;
        return Promise.reject(error);
    }

    return response;

}